import { dew as _isImplementedDew } from "./set-prototype-of/is-implemented";
import { dew as _shimDew } from "./set-prototype-of/shim";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var create = Object.create,
      shim;

  if (!_isImplementedDew()()) {
    shim = _shimDew();
  }

  exports = function () {
    var nullObject, polyProps, desc;
    if (!shim) return create;
    if (shim.level !== 1) return create;
    nullObject = {};
    polyProps = {};
    desc = {
      configurable: false,
      enumerable: false,
      writable: true,
      value: undefined
    };
    Object.getOwnPropertyNames(Object.prototype).forEach(function (name) {
      if (name === "__proto__") {
        polyProps[name] = {
          configurable: true,
          enumerable: false,
          writable: true,
          value: undefined
        };
        return;
      }

      polyProps[name] = desc;
    });
    Object.defineProperties(nullObject, polyProps);
    Object.defineProperty(shim, "nullPolyfill", {
      configurable: false,
      enumerable: false,
      writable: false,
      value: nullObject
    });
    return function (prototype, props) {
      return create(prototype === null ? nullObject : prototype, props);
    };
  }();

  return exports;
}